import { MarketingMessage } from "@app/core/marketing/domain/marketing-message";

export class GetMarketingMessageMapper {
  static deserialize(data: any): MarketingMessage {
    return {
      ...data,
      textAlign: data?.textAlign || "center", // We want our marketing dialog to be centered by default
      closeButtonTop: true, // We want our marketing dialog to have a close button by default
      buttonsConfig: !!data.rightButton
        ? [
            {
              text: data.rightButton.text,
              action_string: 'true',
              ui_color: "primary",
              redirectUrl: data?.rightButton?.redirectUrl || "",
              class: "col-span-12"
            },
          ]
        : [],
    };
  }
}
